import type { Nullable } from '@iheartjane/types';

import { api } from '../api';
import type { MaterializedMenuProduct } from './materializedMenuProduct.types';
import type { GetArgs } from './materializedMenuProduct.utils';
import { materializedMenuProductUrls } from './materializedMenuProduct.utils';

interface SearchArgs {
  productId: string | number;
  storeIds: string[] | number[];
}

/**
 * Search for a product at the given stores
 * @example
 * // POST https://staging-api.nonprod-iheartjane.com/v1/materialized_menu_products/search
 * // Body: { product_id: "123", store_ids: ["456", "789"] }
 */
export const fetchMaterializedMenuProducts = ({
  productId,
  storeIds,
}: SearchArgs): Promise<Nullable<MaterializedMenuProduct[]>> =>
  api.post<Nullable<MaterializedMenuProduct[]>>(
    materializedMenuProductUrls.search(),
    {
      product_id: productId,
      store_ids: storeIds,
    }
  );
export const fetchMaterializedMenuProduct = async (
  args: GetArgs
): Promise<MaterializedMenuProduct> => {
  return api.get<MaterializedMenuProduct>(
    materializedMenuProductUrls.get(args)
  );
};
